import ReactDOM from 'react-dom';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ChooseYourPrice from './components/choose-your-price';
import ChooseYourPriceSessions from './components/choose-your-price-sessions';
import ChooseYourPriceStore from './store';

export function initChooseYourPriceApp(eventId) {
  const targetNode = document.querySelector(`[data-choose-your-price-workflow="${ eventId }"]`);
  const store = new ChooseYourPriceStore(
    targetNode.getAttribute('data-event'),
    targetNode.getAttribute('data-event-name'),
    targetNode.getAttribute('data-booking-url'),
    true
  );
  const root = createRoot(targetNode);
  root.render(
    <ChooseYourPrice store={ store } />
  );
}

export function initChooseYourPriceSessions(el) {
  const eventId = el.getAttribute('data-choose-your-price-sessions');
  const targetNode = document.querySelector(`[data-choose-your-price-workflow="${ eventId }"]`);
  const store = new ChooseYourPriceStore(
    targetNode.getAttribute('data-event'),
    targetNode.getAttribute('data-event-name'),
    targetNode.getAttribute('data-booking-url'),
    targetNode.getAttribute('data-non-cyp-id'),
    targetNode.getAttribute('data-modal-gotocart-button-text'),
    targetNode.getAttribute('data-modal-cart-page-url'),
    targetNode.getAttribute('data-modal_continue_button_text'),
    targetNode.getAttribute('data-cart-expiry-warning-text'),

  );
  const root = createRoot(el);
  root.render(
    <ChooseYourPriceSessions store={ store } />
  );
}


function init(chooseYourPriceEls) {
  // For showing sessions:
  const cypSessions = document.querySelectorAll('[data-choose-your-price-sessions]');
  cypSessions.forEach((el) => {
    initChooseYourPriceSessions(el);
  });
  chooseYourPriceEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      initChooseYourPriceApp(e.target.getAttribute('data-choose-your-price-booking'));
    });
  });
}

export default { init };
